import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=91dc1210&scoped=true&"
import script from "./ItemDetails.vue?vue&type=script&lang=js&"
export * from "./ItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetails.vue?vue&type=style&index=0&id=91dc1210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dc1210",
  null
  
)

export default component.exports